import { Divider, Typography } from 'antd';
import { ColoredPill } from 'components/Forms/ColoredPill';
import ShowIfTrue from 'components/Forms/ShowIfTrue';
import { ProjectApproval } from 'Core/Api/Api';
import ConfigService from 'Core/ConfigService';
import Utility from 'Core/Utility';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

interface Props {
  approvals?: ProjectApproval[]
}

const ApprovalContainer = styled.div`
  display: flex;
  flex-direction:column;
  align-content: flex-start;
  gap: 3px;
`


export default ({ approvals }: Props) => {
  let config = ConfigService.getSync();

  const getFilteredApprovals = () => {
    return approvals?.filter(approval => {
      return approval.status == "Rejected";
    });
  }

  return <>
    <Divider />
    <h3>Update(s) Required</h3>
    {getFilteredApprovals()?.map(approval => (
      <>
        <ApprovalContainer>
          {/* <Typography.Text><b>Action: </b><ColoredPill value={approval.status} options={[{ color: "green", value: "Approved" }, { color: "red", value: "Rejected" }]} /></Typography.Text> */}
          {/* <Typography.Text><b>by:</b> {approval.createdBy}</Typography.Text> */}
          <Typography.Text><b>on: </b> {Utility.renderDateWithReference(moment(approval?.creationDate), config.Display.DateTimeFormat)}</Typography.Text>
          <ShowIfTrue condition={!!approval.reason}>
            <Typography.Text><b>Note: </b> {approval?.reason}</Typography.Text>
          </ShowIfTrue>
          <Divider />
        </ApprovalContainer>

      </>
    ))}
  </>;
}